import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "table table-hover align-middle" }
const _hoisted_3 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  colspan: "4",
  class: "fw-bold small text-uppercase text-muted"
}
const _hoisted_6 = { class: "begin-date" }
const _hoisted_7 = { class: "end-date" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { class: "vat-percentage" }
const _hoisted_10 = { class: "is-vat-included" }
const _hoisted_11 = { class: "mas mas-fill-1" }
const _hoisted_12 = { class: "price-type" }
const _hoisted_13 = { class: "data-provider" }
const _hoisted_14 = { class: "supply-channel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AlertError2, {
      error: _ctx.iPrinsPricesUI.getError(),
      class: "mb-3"
    }, null, 8, ["error"]),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('beginDate')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('endDate')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('price')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('vatPercentage')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('inclVat')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('priceType')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('source')), 1),
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('supplyChannel')), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.iPrinsPricesUI.isNotReady())
          ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
              key: 0,
              "n-cols": 4
            }))
          : (_ctx.iPrinsPricesUI.isReady() && !_ctx.hasPrices)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('noResults')), 1)
              ]))
            : (_ctx.iPrinsPricesUI.isReady() && _ctx.hasPrices)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.iPrinsPrices, (priceItem) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: priceItem.code,
                    class: "position-relative"
                  }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.formatDate(new Date(priceItem.begin_date))), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString((priceItem?.end_date) ? _ctx.formatDate(new Date(priceItem.end_date)) : null), 1),
                    _createElementVNode("td", _hoisted_8, "€ " + _toDisplayString(priceItem.price.toFixed(2)), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(priceItem.vat_percentage) + "%", 1),
                    _createElementVNode("td", _hoisted_10, [
                      _createElementVNode("i", _hoisted_11, _toDisplayString(priceItem.is_vat_included_boolean ? 'check' : 'close'), 1)
                    ]),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(priceItem.price_type.description), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(priceItem.data_provider.description), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(priceItem.supply_channel.description), 1)
                  ]))
                }), 128))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}